export default {
  h1: {
    fontWeight: 400,
    fontSize: 26,
    letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 700,
    fontSize: 20,
    letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 700,
    fontSize: 28,
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 700,
    fontSize: 24,
    letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 700,
    fontSize: 20,
    letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 700,
    fontSize: 14,
  },
  button: {
    textTransform: 'none',
    fontSize: 16,
  },
  body1: {
    fontSize: 16,
  },
  body2: {
    fontSize: 14,
  },
  subtitle1: {
    fontSize: 24,
    lineHeight: '28px',
    letterSpacing: '0.17px',
  },
  subtitle2: {
    lineHeight: '20px',
    fontSize: 16,
    letterSpacing: 0,
    fontWeight: 'normal',
  },
  fontFamily: ['"League Spartan"', 'Roboto', '"Helvetica Neue"', 'Arial'].join(','),
};
